import { UcoastEl } from '@/scripts/core/UcoastEl';
import { currentTargetRequired, qsRequired } from '@/scripts/core/global'

export class BaSwiper extends UcoastEl {
	static htmlSelector = 'ba-swiper';
	beforeMedia: HTMLElement
	afterMedia: HTMLElement
	input: HTMLInputElement
	button: HTMLElement
	constructor() {
		super();
		this.beforeMedia = qsRequired('[data-swiper-before]', this)
		this.afterMedia = qsRequired('[data-swiper-after]', this)
		this.input = qsRequired('[data-swiper-input]', this)
		this.button = qsRequired('[data-swiper-button]', this)
		this.input.addEventListener('input', this.onInputChange.bind(this))
	}
	onInputChange(e: Event) {
		const target = currentTargetRequired(e) as HTMLInputElement
		const sliderPos = target.value;
		let width = 100 - parseInt(sliderPos)
		if (width < 1) {
			width = 0
		}
		if (width > 99) {
			width = 100
		}
		this.afterMedia.style.width = `${width}%`;
		this.button.style.left = `calc(${sliderPos}%)`;
	}
}
